module.exports = __webpack_public_path__ + "static/media/21ECLAC4.1c1d2df1.jpg";